$(function () {

    $(window).scroll(function() {
        var windowTop = $(window).scrollTop();
        windowTop > 600 ? $('.nav').addClass('show') : $('.nav').removeClass('show');
    });

    const $modal = $('#modal');
    $modal
        .on('click', function(e) {
            if (e.target === $modal.get(0)) {
                $('[data-role="hide-popup"]').trigger('click');
            }
        });
    $('[data-role="show-popup"]')
        .on('click', function() {
            const $t = $(this),
                trg = $t.data('target'),
                vid = $t.data('vid'),
                $trg = $(trg);
            if (trg === '#player') {
                $trg.append(
                    $('<iframe/>').attr({
                        src: 'https://www.youtube.com/embed/' + vid  + '?rel=0&amp;autoplay=1',
                        frameborder: 0,
                        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
                        allowfullscreen: ''
                    })
                );
            }
            $trg.show();
            $('html,body').css('overflow', 'auto');
            $modal.fadeIn(300);
            return false;
        });
    $('[data-role="hide-popup"]')
        .on('click', function() {
            $modal.fadeOut(300, function() {
                $('html,body').css('overflow', 'auto');
                $('iframe', $modal).remove();
                $('.popup').hide();
            });
            return false;
        });



    let $prizesSlider = $('.prizes__slider');
    if ($prizesSlider.length) {
        $prizesSlider.slick({
            slidesToShow: 3,
            dots: false,
            arrows: true,
            autoplay: true,
            transition: "7s",
            lazyLoad: 'ondemand',
            prevArrow: '<span class="btn_prev"></span>',
            nextArrow: '<span class="btn_next"></span>'
        });
    }

    let $stepSlider = $('.steps__main');
    if ($stepSlider.length) {
        const $stepItem = $('.steps__nav-item');
        $stepSlider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: false,
            fade: true,
            draggable: false,
            transition: "7s"
        });
        $('[data-role="step-select"]')
            .on('click', function(){
                var n = $(this).data('target') || 0;
                $stepSlider.slick('slickGoTo', n);
                return false;
            });
        $stepSlider
            .on('beforeChange', function(event, slick, currentSlide, nextSlide){
                $stepItem.removeClass('active').eq(nextSlide).addClass('active');
            });
    }

    let $animationSlider = $('.header__drop-interactive');
    if ($animationSlider.length) {
        $animationSlider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3600,
            speed: 600,
            draggable: false,
            fade: true,
            cssEase: 'linear'
        });
    }

    //STEP
    $('.js-steps')
        .each(function() {
            var
                $s = $('.js-steps-item', $(this)),
                i = 0;
            setInterval(function() {
                $s.removeClass('active').eq(i).addClass('active');
                i++;
                if (i >= $s.length) i = 0;
            }, 1400);
        });


    function parallaxMove($el, kx, ky, offset) {
        $el.css({
            'transform':'translate(' + (-kx * offset) + 'px, ' + (-ky * offset) + 'px)'
        });
    }
    var $window = $(window),
        hc = $window.width() * .5,
        vc = $window.height() * .5,
        mx = 0,
        my = 0,
        kx = 0,
        ky = 0;
    $window
        .on('mousemove', function(e) {
            mx = e.pageX - $(this).scrollLeft();
            my = e.pageY - $(this).scrollTop();
            kx = (mx - hc) / hc;
            ky = (my - vc) / vc;
            parallaxMove($('.parallax_1'), kx, ky, -15);
            parallaxMove($('.parallax_2'), kx, ky, -5);
            parallaxMove($('.parallax_3'), kx, ky, 5);
            parallaxMove($('.parallax_4'), kx, ky, 15);
            parallaxMove($('.parallax_5'), kx, ky, 25);
            parallaxMove($('.parallax_6'), kx, ky, -10);
        });


    let $encyclopediaSlider = $('.encyclopedia__slider');
    if ($encyclopediaSlider.length) {
        $encyclopediaSlider.slick({
            slidesToShow: 3,
            dots: false,
            arrows: true,
            autoplay: true,
            prevArrow: '<span class="btn_prev"></span>',
            nextArrow: '<span class="btn_next"></span>'
        });
    }

    let hsl = $('.hotels__slide').length,
        randomSlideId = Math.random() * hsl | 0;
    $('.hotels__slider').slick({
        slidesToShow: 4,
        dots: false,
        arrows: true,
        autoplay: true,
        prevArrow: '<span class="btn_prev"></span>',
        nextArrow: '<span class="btn_next"></span>',
        initialSlide: randomSlideId
    });



    //слайдер для экспертов в расписании
    const $eSlider = $('[data-role="e-slider"]');
    if ($eSlider.length) {
        $eSlider.slick({
            slidesToShow: 3,
            prevArrow: '<img class="schedule__expert-prev" src="https://profi.travel/uploads/workshops/projects/dubai20/img/expert_prev.png" alt=""/>',
            nextArrow: '<img class="schedule__expert-next" src="https://profi.travel/uploads/workshops/projects/dubai20/img/expert_next.png" alt=""/>'
        });
    }

    //рандомный вывод СПО
    var
        //СПО ANEX Tour
        spo1 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo1.png",
                "title": "Отдых в Howard Johnson Hotel Bur Dubai 3*",
                "validity": "до 18.03.2020",
                "date": "18.03.2020",
                "price": "от 65 873 рублей за двоих",
                "duration": "7 ночей",
                "dscr": "Standard Room, перелет, питание BB",
                "url": "/spo"
            }
        ],

        //СПО Coral Travel
        spo2 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo2.png",
                "title": "CITYMAX HOTELS BUR DUBAI 3*",
                "validity": "до 30.12.2020",
                "date": "05.12.2020",
                "price": "58 808 руб. ½ DBL",
                "duration": "6-7 ночей",
                "dscr": "Проживание в отеле на базе питания «Завтраки»",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo2.png",
                "title": "SIGNATURE HOTEL AL BARSHA 4*",
                "validity": "до 27.12.2020",
                "date": "05.12.2020",
                "price": "63 142 руб. ½ DBL",
                "duration": "6-7 ночей",
                "dscr": "Проживание в отеле на базе питания «Завтраки»",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo2.png",
                "title": "GHAYA GRAND HOTEL 5*",
                "validity": "до 30.04.2021",
                "date": "05.12.2020",
                "price": "66 442 руб. ½ DBL",
                "duration": "6-7 ночей",
                "dscr": "Проживание в отеле на базе питания «Завтраки»",
                "url": "/spo"
            }
        ],

        //СПО Karlson Tourism
        spo3 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo3.png",
                "title": "Отдых в Atlantis, The Palm 5*",
                "validity": "до 31.03.2020",
                "date": "ежедневно",
                "price": "от 2 517 долларов",
                "duration": "7 ночей",
                "dscr": "проживание",
                "url": "/spo"
            }
        ],

        //СПО Kazunion
        spo4 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo4.png",
                "title": "Бесплатный ПЦР-тест для гостей Rixos Premium Dubai",
                "validity": "до 31.01.2021",
                "date": "26.12.2020",
                "price": "3444 USD (2 взрослых)",
                "duration": "от 5 ночей",
                "dscr": "бесплатный ПЦР-тест для гостей Rixos Premium Dubai старше 14 лет (перелет из Алматы и Нурсултана)",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo4.png",
                "title": "Бесплатный ПЦР-тест для гостей Rixos The Palm Dubai Hotel and Suites",
                "validity": "до 31.01.2021",
                "date": "26.12.2020",
                "price": "4396 USD (2 взрослых)",
                "duration": "от 5 ночей",
                "dscr": "бесплатный ПЦР-тест для гостей Rixos The Palm Dubai Hotel and Suites старше 14 лет (перелет из Алматы и Нурсултана)",
                "url": "/spo"
            }
        ],

        //СПО PAC Group
        spo5 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo5.png",
                "title": "Отдых в Le Meridien Mina Seyahi Beach Resort & Marina 5*",
                "validity": "бессрочно",
                "date": "любые",
                "price": "1 187 долларов на двоих",
                "duration": "от 6 до 14 ночей",
                "dscr": "проживание, авиаперелет, трансфер",
                "url": "/spo"
            }
        ],

        //СПО Space Travel
        spo6 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo6.png",
                "title": "Спеццены на проживание в JA Beach Hotel 5*",
                "validity": "до 18.12.2020",
                "date": "01.11.2020 — 30.09.2021",
                "price": "от 258 USD",
                "duration": "от 1 до 21 ночи",
                "dscr": "Проживание, BB",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo6.png",
                "title": "Спеццены на проживание в Jumeirah Beach Hotel 5* и ужины в подарок",
                "validity": "до 30.11.20",
                "date": "02.11.20 — 13.01.22",
                "price": "от 526 USD",
                "duration": "от 1 до 21 ночи",
                "dscr": "Проживание",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo6.png",
                "title": "Скидка до 70% на проживание в Fairmont The Palm 5* и ужины в подарок",
                "validity": "до 30.11.20",
                "date": "04.10.2020 — 25.09.2021",
                "price": "от 157 USD",
                "duration": "от 1 до 21 ночи",
                "dscr": "Проживание",
                "url": "/spo"
            }
        ],

        //СПО Voyager Group
        spo7 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo7.png",
                "title": "Отдых в Rixos Premium Dubai 5*",
                "validity": "до 04.05.2020",
                "date": "с 27.01.2020 по 30.04.2020",
                "price": "от 1 550 долларов",
                "duration": "7 ночей",
                "dscr": "перелет из Сочи, проживание, трансфер, медицинская страховка",
                "url": "/spo"
            }
        ],

        //СПО Русский Экспресс
        spo8 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo8.png",
                "title": "Отдых в Дубае",
                "validity": "до 25.11.2020",
                "date": "27.11.2020",
                "price": "от 35 129 руб./чел.",
                "duration": "7 ночей",
                "dscr": "авиаперелет, трансферы, проживание, питание",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo8.png",
                "title": "Отдых в Дубае",
                "validity": "до 03.12.2020",
                "date": "05.12.2020",
                "price": "от 35 129 руб./чел.",
                "duration": "7 ночей",
                "dscr": "авиаперелет, трансферы, проживание, питание",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo8.png",
                "title": "Отдых в Дубае",
                "validity": "до 09.12.2020",
                "date": "11.12.2020",
                "price": "от 36 511 руб./чел.",
                "duration": "7 ночей",
                "dscr": "авиаперелет, трансферы, проживание, питание",
                "url": "/spo"
            }
        ],

        //СПО ART TOUR
        spo9 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo9.png",
                "title": "W DUBAI – THE PALM 5*",
                "validity": "до 30.11.2020",
                "date": "до 30.11.2020",
                "price": "от 1115 USD",
                "duration": "7 ночей",
                "dscr": "½ Dbl, RO, авиабилет, страховка",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo9.png",
                "title": "ANDAZ DUBAI THE PALM 5*",
                "validity": "09.11.2020 – 23.11.2020",
                "date": "03.11.2020 – 31.10.2021",
                "price": "803 USD",
                "duration": "7 ночей",
                "dscr": "½ Dbl, RO, авиабилет, страховка",
                "url": "/spo"
            },
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo9.png",
                "title": "ONE&ONLY ROYAL MIRAGE 5*",
                "validity": "до 30.11.2020",
                "date": "до 30.11.2020",
                "price": "от 2399 USD",
                "duration": "7 ночей",
                "dscr": "½ Arabian Court Deluxe Room / BB",
                "url": "/spo"
            }
        ],

        //СПО Intourist
        spo10 = [
            {
                "logo": "/uploads/workshops/projects/dubai20/img/spo_logo10.png",
                "title": "Отдых в Anantara Dubai The Palm 5*",
                "validity": "бессрочно",
                "date": "20.03.2020",
                "price": "от 1 657 долларов",
                "duration": "7 ночей",
                "dscr": "перелет, проживание, страховка, трансфер, питание BB",
                "url": "/spo"
            }
        ];

    function generateSPO(spo) {
        var $teaser = $('.js-spo-teaser1'),
            n = Math.floor(Math.random() * spo.length);
        $('.js-text1', $teaser).html('')

            .append(
                $('<img/>').addClass('spo__logo').attr('src', spo[n].logo)
            )
            .append(
                $('<p/>').addClass('spo__title').text(spo[n].title)
            )
            .append(
                $('<p/>').addClass('spo__validity').html('<b>Срок действия СПО:</b> ' + spo[n].validity)
            )
            .append(
                $('<p/>').addClass('spo__date').html('<b>Даты заездов:</b> ' + spo[n].date)
            )
            .append(
                $('<p/>').addClass('spo__price').html('<b>Стоимость:</b> ' + spo[n].price)
            )
            .append(
                $('<p/>').addClass('spo__duration').html('<b>Продолжительность:</b> ' + spo[n].duration)
            )
            .append(
                $('<p/>').addClass('spo__dscr').html('<b>В стоимость тура включено:</b> ' + spo[n].dscr)
            )
            .append(
                $('<a />').addClass('spo__btn').attr({'href': spo[n].url}).html('Смотреть все СПО')
            );
    }

    $('.js-spo-btn').on('click', function () {
        const cid = $(this).data('company');
        let spo;
        switch (cid) {
            case 1: spo = spo1; break;
            case 2: spo = spo2; break;
            case 3: spo = spo3; break;
            case 4: spo = spo4; break;
            case 5: spo = spo5; break;
            case 6: spo = spo6; break;
            case 7: spo = spo7; break;
            case 8: spo = spo8; break;
            case 9: spo = spo9; break;
            case 10: spo = spo10; break;
            default: spo = spo1; break;
        }
        generateSPO(spo);
    });
    generateSPO(spo8);



    console.log('Document ready');


});
